import { render, staticRenderFns } from "./ComparingPriceSite.vue?vue&type=template&id=7a527567&"
import script from "./ComparingPriceSite.vue?vue&type=script&lang=ts&"
export * from "./ComparingPriceSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports